import { KeyValue } from '@angular/common';

export function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}

export function isDefined(val: any) {
  return val !== null && val !== undefined;
}

export function fromEntries(iterable) {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
}

export function toList(x: any): any[] {
  switch (true) {
    case x instanceof Array:
      return x;
    case typeof x === 'undefined':
      return [];
    default:
      return [x];
  }
}

export function defaults(...args) {
  return args.reverse().reduce((acc, obj) => ({ ...acc, ...obj }), {});
}

export function originalOrder(a: KeyValue<string, string>, b: KeyValue<string, string>): number {
  return 0;
}

export function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export const isObject = (value) => {
  return !!(value && typeof value === 'object' && !Array.isArray(value));
};

export const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0;
};

export const isArray = (value) => {
  return !!(value && Array.isArray(value));
};

export const isString = (value) => {
  return !!(value && typeof value === 'string');
};

export const isNumber = (value) => {
  return !!(value && typeof value === 'number');
};

export const isBoolean = (value) => {
  return !!(value && typeof value === 'boolean');
};


export const isEqualObjects = (obj1, obj2) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
};


/**
 * Convert object to query string params for url
 * @param obj
 * @private
 */
export function objToQueryString(obj) {
  const keyValuePairs = Object.entries(obj).map(([key, value]) => {
    if (isArray(value)) {
      value = (value as any[]).join(',');
    }
    return `${ key }=${ encodeURIComponent(value as any) }`;
  });
  return keyValuePairs.join('&');
}
export function decoder(arr, indices) {
  return indices.reduce(function(previousValue, currentValue){
    return previousValue + arr[currentValue];
  }, '');
}

export function decodeHexStr(str: string) {
  const byteArray = new Uint8Array(str.match(/[\da-f]{2}/gi).map((h: string) => parseInt(h, 16)));
  const decodedString = new TextDecoder().decode(byteArray);
  return JSON.parse(decodedString);
}

export function isHexString(str: string): boolean {
  return /^[0-9a-fA-F]+$/i.test(str);
}


export function matchFirstToSecondArrayLength(arr1: any[], arr2: any[]) {
  if (!arr1?.length || !arr2?.length) {
    return arr1;
  }

  const arr1Length = arr1.length;
  const arr2Length = arr2.length;


  if (arr1Length < arr2Length) {

    const repeatTimes = Math.ceil(arr2Length / arr1Length);

    let extendedFsNumbers = [];
    for (let i = 0; i < repeatTimes; i++) {
      extendedFsNumbers = extendedFsNumbers.concat(arr1);
    }

    // Trim the array to match the exact length of lootboxImgs
    arr1 = extendedFsNumbers.slice(0, arr2Length);
  }

  return arr1;
}

export function removeDuplicatesInObjects(array, property) {
  const uniqueIds = [];

  const unique = array.filter(element => {
    const isDuplicate = uniqueIds.includes(element[property]);

    if (!isDuplicate) {
      uniqueIds.push(element[property]);

      return true;
    }

    return false;
  });

  return unique;
}
